'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import MaterialRadio from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
const StyledRadio = styled(MaterialRadio)(({ theme }) => ({
    height: '1.875rem',
    width: '2.125rem',
    color: theme.tokens.FuelColorBorderDark,
    marginLeft: theme.spacing(1),
    '&.Mui-focusVisible .MuiSvgIcon-root': {
        borderRadius: '50%',
        boxShadow: `0 0 0 0.125rem ${theme.tokens.FuelColorFocused}`
    },
    '&:hover': {
        backgroundColor: 'transparent'
    },
    '&.Mui-checked:hover': {
        backgroundColor: 'transparent'
    },
    boxSizing: 'border-box'
}));
export const Radio = React.forwardRef((props, ref) => (_jsx(StyledRadio, { ref: ref, ...props })));
Radio.displayName = 'Radio';
